// Port of Plunk.Reporting/CategoryClassifier.cs.
//
// Maps a product row to a top-level category. Title keywords take
// priority because the Robb & Stucky product feed has stale tagging
// (e.g. Sleepers tagged as Nightstand). Falls through to feed values
// then "Other".

// Ordered: first match wins. Specific patterns come first.
const TITLE_RULES = [['Sectionals', /\bsectional/i], ['Sleepers', /\bsleeper\b/i], ['Sofas', /\b(sofa|loveseat|settee)/i], ['Recliners', /\brecliner/i], ['Dining Tables', /\b(dining\s+(table|base)|dining\s+set)/i], ['Dining Chairs', /\b(dining\s+chair|bar\s+stool|counter\s+stool)/i], ['Beds', /\b(bed|headboard)\b/i], ['Bedroom Storage', /\b(nightstand|dresser|chest|armoire|wardrobe)\b/i], ['Buffets & Sideboards', /\b(buffet|sideboard|credenza|server)\b/i], ['Cabinets & Hutches', /\b(cabinet|hutch|china)\b/i], ['Bookcases', /\b(bookcase|bookshelf|étagère|etagere|shelving)\b/i], ['Coffee & Cocktail Tables', /\b(coffee\s+table|cocktail\s+table|bunch\s+table)/i], ['End & Side Tables', /\b(end\s+table|side\s+table)\b/i], ['Console Tables', /\bconsole\s+table/i], ['Media & Consoles', /\b(media\s+console|tv\s+stand|media\s+cabinet)\b/i], ['Accent Tables', /\b(accent\s+table|drink\s+table|martini\s+table)/i],
// Catch-all for any remaining "table(s)"
['Other Tables', /\btables?\b/i],
// Accent-chair patterns include "skirted side chair" — RS uses
// "side chair" for accent pieces — so we route those to Accent Chairs.
['Accent Chairs', /\b(accent\s+chair|wing\s+chair|club\s+chair|swivel\s+chair|arm\s+chair|armchair|skirted\s+side\s+chair|barrel\s+chair)/i], ['Ottomans & Benches', /\b(ottoman|bench|pouf)\b/i], ['Outdoor', /\b(outdoor|patio|teak)\b/i], ['Lighting', /\b(lamp|chandelier|sconce|pendant)\b/i], ['Rugs', /\brug\b/i], ['Mirrors & Wall Art', /\b(mirror|artwork|wall\s+art)\b/i], ['Accessories', /\b(pillow|throw|vase|tray|sculpture|candle|bowl|decor|accessor)/i],
// Bare "side chair" without modifier is typically dining/desk.
['Dining Chairs', /\bside\s+chair\b/i], ['Chairs', /\bchair\b/i]];
export function classifyCategory(row) {
  const title = row && row.title;
  if (title && String(title).trim()) {
    for (const [cat, pattern] of TITLE_RULES) {
      if (pattern.test(title)) return cat;
    }
  }
  // Fall back to merchant ProductType leaf
  if (row && row.productType && String(row.productType).trim()) {
    const leaf = lastSegment(row.productType);
    if (leaf) return leaf;
  }
  // Fall back to GoogleProductCategory leaf
  if (row && row.googleProductCategory && String(row.googleProductCategory).trim()) {
    const leaf = lastSegment(row.googleProductCategory);
    if (leaf) return leaf;
  }
  return 'Other';
}
function lastSegment(path) {
  const parts = String(path).split(/[>/,]/).map(p => p.trim()).filter(Boolean);
  return parts.length ? parts[parts.length - 1] : null;
}
export default {
  classifyCategory
};